import React, { Component } from "react";
import { connect } from "react-redux";
import { ClientHubRoutes } from "./components/Routes/Pages";
import Routes from "./components/RoutesCore";
import Preloader from "./components/Preloader";
import AuthCentral from "./services/AuthCentral/AuthService";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";

import ForgotPassword from "./components/CustomFeatures/ForgotPassword";

class App extends Component {
  state = { isLoading: true, isMounted: false };

  constructor(props, nextContext) {
    super(props, nextContext);

    const that = this;

    window.addEventListener("storage", function (e) {
      if (e.key === "alive") {
        localStorage.setItem("alive", true);
      }
      if (e.key === "token") {
        that.pageRefresh();
      }
    });
    window.addEventListener("unload", this.removeSession, true);
    AuthCentral.getUserFromLocalStorage()
      .then(() => {
        if (AuthCentral.isAuthenticated) {
          const { userDetails } = AuthCentral;
          this.props.dispatch({
            type: "USER_AUTHENTICATED",
            payload: {
              isAuthenticated: AuthCentral.isAuthenticated,
              ...userDetails,
            },
          });
          this.setState({ isLoading: false });
        }
        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }

  removeSession = () => {
    localStorage.removeItem("alive");
    sessionStorage.setItem("refreshed", true);
    sessionStorage.setItem("refreshTime", Date.now());
  };

  componentWillUnmount() {
    window.removeEventListener("unload", this.removeSession, true);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.User.client_id &&
      prevProps.User.client_id &&
      this.props.User.client_id !== prevProps.User.client_id
    ) {
      this.pageRefresh();
    }
  }

  pageRefresh = () => {
    this.setState({ isLoading: true });
    AuthCentral.getUserFromLocalStorage().then(() => {
      if (AuthCentral.isAuthenticated) {
        const { userDetails } = AuthCentral;
        this.props.dispatch({
          type: "USER_AUTHENTICATED",
          payload: {
            isAuthenticated: AuthCentral.isAuthenticated,
            ...userDetails,
          },
        });
        this.setState({ isLoading: false });
      }
      this.setState({ isLoading: false });
    });
  };
  render() {
    return this.state.isLoading ? (
      <Preloader />
    ) : (
      <Routes
        routes={ClientHubRoutes}
        customSiteConfigurations={{
          ForgotPasswordAction: ({ _ }) => <ForgotPassword _={_} />,
        }}
      />
    );
  }
}

const mapStateToProps = (state) => state;
export default connect(mapStateToProps)(App);
